// src/pages/BusinessVerificationPendingPage.js
import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

const BusinessVerificationPendingPage = ({ navigateTo }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4 sm:p-6">
            <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-8 space-y-6 text-center">
                <div className="flex flex-col items-center">
                    <div className="p-3 bg-yellow-100 rounded-full">
                        <ClockIcon className="h-12 w-12 text-yellow-600" />
                    </div>
                    <h2 className="mt-4 text-3xl font-extrabold text-gray-900">
                        Business Under Review
                    </h2>
                </div>

                <p className="text-gray-600 leading-relaxed">
                    Thank you for registering your business with LocalRewards! Your details have been successfully submitted for verification.
                </p>

                <div className="p-4 bg-yellow-50 rounded-lg">
                    <p className="text-sm text-gray-500 font-medium">
                        We are currently reviewing your information to ensure everything is correct. This process typically takes
                        <span className="font-semibold text-gray-700"> 24-48 hours.</span>
                    </p>
                </div>

                <p className="text-gray-600">
                    We will send a confirmation email to your registered address as soon as your account is approved and ready to use.
                </p>

                <div className="mt-6">
                    <button
                        onClick={() => navigateTo('login')}
                        className="w-full sm:w-auto px-6 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Return to Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BusinessVerificationPendingPage;